export const markets = new Set([
    '1001', '1002', '1003', '1004', "105",
    "99", "1071", "1087", "120", "122", "132", 
    "133", "135", "136", "137", "1033", "1041", 
    "1072", "1073","1075", "1078", "1079", 
    "1081", "1082", "1084", "1088",
    "125", "126"
]);
